<template>
  <donut-tabs
    class="m-tx4"
    :tabs="tabs"
    :initial-tab="initialTab"
    :can-select-tabs="false"
  />
</template>

<script setup>
import { computed, inject } from 'vue';
import { useStore } from 'vuex';

const { state } = useStore();
const $i18n = inject('$i18n');

const props = defineProps({
  initialTabValue: { type: String, required: true },
});

const tabs = [
  { title: 'Rewards', value: 'show', link: '/rewards/settings' },
  { title: 'Fulfillment history', value: 'fulfillment', link: '/rewards/redemptions' },
];

const initialTab = computed(() => tabs.find((tab) => tab.value === props.initialTabValue));
</script>
